<template>
  <div id="backup">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>
<script>
export default {
  name: 'backup'
}
</script>




// WEBPACK FOOTER //
// src/views/contract/backup/Backup.vue